'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// /data/jenkins_slave/epjenkins81/workspace/IWT-GIT/00XXX-Component-Loader/node_modules/axios/lib/cancel/isCancel.js
// module id = 45
// module chunks = 0 1